import React from 'react';

const NewsInside = React.lazy(() => import('pages/NewsInside/pages/NewsInsidePage'));
const NewsInsideDetail = React.lazy(() => import('pages/NewsInside/pages/NewsInsideDetail'));

const newsInsideRoutes = [
  {
    path: '/news-inside',
    exact: true,
    name: 'Bảng tin nội bộ',
    allowLoggedIn: true,
    component: NewsInside,
  },
  {
    path: '/news-inside/detail/:id',
    exact: true,
    name: 'Chi tiết bảng tin nội bộ',
    allowLoggedIn: true,
    component: NewsInsideDetail,
  },
];

export default newsInsideRoutes;
